import { API } from "@/lib/api";

export const slvx = (c) => `${((c || 0) / 100).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} SLVX`;
export const eurC = (c) => `${((c || 0) / 100).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export function CardVisual({ card, name, qrSrc = `${API}/wallet/me/qr.svg`, onQr }) {
  const role = card.holder_role === "operatore" ? "Operatore" : "Utente";
  return (
    <div className="relative w-full overflow-hidden rounded-[4.5%/6.8%] shadow-[0_20px_60px_-20px_rgba(8,145,178,.6)] [container-type:inline-size]" data-testid="loyalty-card">
      <img src="/brand/card-master.webp" alt="DoctorSelvix Card – Carta fedeltà" className="block w-full select-none" draggable={false} />
      {card.status !== "attiva" && <span className="absolute left-[4%] top-[5%] rounded-full bg-rose-600 px-[2cqw] py-[0.6cqw] text-[2.2cqw] font-bold text-white" data-testid="card-suspended-badge">TESSERA SOSPESA</span>}
      <div className="absolute left-[33.85%] top-[81%] flex h-[7.6%] w-[34.8%] flex-col items-center justify-center leading-none text-[#0c2036]">
        <span className="font-mono text-[2.7cqw] font-extrabold tracking-wider" data-testid="card-number">{card.card_number}</span>
        <span className="mt-[0.4cqw] max-w-full truncate text-[1.6cqw] font-semibold uppercase" data-testid="card-holder">{name} · {role}</span>
      </div>
      <button type="button" onClick={onQr} aria-label="Mostra QR a schermo intero" data-testid="card-qr-btn"
        className="absolute left-[80.6%] top-[66.7%] flex h-[23.3%] w-[14.6%] items-center justify-center">
        <img src={qrSrc} alt="QR del Selvix Wallet" className="aspect-square w-[88%] rounded-[0.6cqw] bg-white" />
      </button>
    </div>
  );
}
